module.exports = __webpack_public_path__ + "media/application/images/banner-bg-bbe162c3955dd694e8ffe334a4ef38a7.jpg";